import React from 'react';
import {t} from '@lingui/core/macro';

import useOAuthFinish from '../../model/useOAuthFinish';

const OAuthFinishScreen: React.FC = () => {
    useOAuthFinish();

    return <>{t`Авторизация завершена, закрытие...`}</>;
};

export default OAuthFinishScreen;
